import {Action} from "redux";
import {ICustomerMessageRoomActionCreator} from "../action/customer_message_room_action";
import {
    SendMessageByCustomerRequest,
    CreateMessageRoomByCustomerRequest,
} from "../request/message_room_request";

interface ICustomerMessageRoomDispatcher {

    createMessageRoom(item: CreateMessageRoomByCustomerRequest): void;

    sendMessageRoom(item: SendMessageByCustomerRequest): void;

    destroyMessageRoom(): void;

}

class Dispatcher implements ICustomerMessageRoomDispatcher {

    constructor(private dispatch: (action: Action) => void,
                private actionCreator: ICustomerMessageRoomActionCreator) {

    }

    public createMessageRoom = (item: CreateMessageRoomByCustomerRequest): void => {
        this.dispatch(this.actionCreator.requestCreateMessageRoomAction(item));
    };

    public sendMessageRoom = (item: SendMessageByCustomerRequest): void => {
        this.dispatch(this.actionCreator.requestSendMessageRoomAction(item));
    };

    public destroyMessageRoom = (): void => {
        this.dispatch(this.actionCreator.requestDestroyMessageRoomAction());
    };

}

const createCustomerMessageRoomDispatcher = (dispatch: (action: Action) => void, actionCreator: ICustomerMessageRoomActionCreator): ICustomerMessageRoomDispatcher => {
    return new Dispatcher(dispatch, actionCreator);
};

export {ICustomerMessageRoomDispatcher, createCustomerMessageRoomDispatcher};



// WEBPACK FOOTER //
// ./src/presentation/dispatcher/customer_message_room_dispatcher.ts